module.exports = __webpack_public_path__ + "img/asset-reports.624d70f4.png";